import { Chip, useTheme } from '@mui/material';
import { ReadonlyCoverageChipGroup as ReadonlyCoverageChipGroupSchema } from '@/schemas/sceneDataSchema';
import { useCoverageAttribute } from '@/hooks/use-quote';

export const ReadonlyCoverageChipGroupFormElement = ({ component }: { component: ReadonlyCoverageChipGroupSchema }) => {
  const theme = useTheme();
  const { options, findSelectedIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const selectedIndex = findSelectedIndex();
  const selectedOption = selectedIndex >= 0 ? options[selectedIndex] : null;

  if (!selectedOption) return null;

  return (
    <Chip
      label={selectedOption.label}
      variant='filled'
      sx={{
        backgroundColor: theme.palette.action.selected,
        color: theme.palette.text.primary,
        fontWeight: 'medium',
      }}
    />
  );
};
